export const UNSORTABLE_DATA_EXPLORER_COLUMNS = new Set([
  'email_addresses',
  'ip_addresses',
  'client_fingerprints',
]);
